import { render, staticRenderFns } from "./AttacksCountByHashtags.vue?vue&type=template&id=4b18539f&scoped=true"
import script from "./AttacksCountByHashtags.vue?vue&type=script&lang=ts"
export * from "./AttacksCountByHashtags.vue?vue&type=script&lang=ts"
import style0 from "./AttacksCountByHashtags.vue?vue&type=style&index=0&id=4b18539f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18539f",
  null
  
)

export default component.exports